export default Object.freeze({
  SETTING_MANUAL: '설정 매뉴얼',
  PRODUCT_MANUAL: '상품 매뉴얼',
  ORDER_MANUAL: '주문/배송 매뉴얼',
  MEMBER_MANUAL: '회원 매뉴얼',
  BOARD_MANUAL: '게시판 매뉴얼',
  PROMOTION_MANUAL: '프로모션 매뉴얼',
  DESIGN_MANUAL: '디자인 매뉴얼',
});
